// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"layout_visuallyHidden__PUh4Z","header":"layout_header__ultV7"};